<template>
  <div id="reporte_embarquez_grupo" data-app>
    <div>
      <v-breadcrumbs :items="breadcrumbs" v-if="!is_consignatario">
        <v-icon slot="divider">forward</v-icon>
      </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12>
           <base-material-card
          color="primary"
          icon="library_books"
          title="Reporte de Embarques Grupo"
          class="elevation-1 px-5 py-3"
        >
            <v-card-actions>
            
              <v-spacer></v-spacer>

            </v-card-actions>
            <v-card-text>

              <!-- Buscador -->
              <v-form ref="form" lazy-validation>
              <v-container fluid fill-height>
                <v-row wrap>
                  <v-col sm="12" md="6" lg="6">
                    <span v-if="permisoSeleccionar">
                      <v-autocomplete v-model="model.consignatario" :items="consignatarios" multiple
                      :loading="loading_consignatarios"  item-text="metadato" item-value="metadato"
                        label="Buscar por Consignatario" :rules="[validaOpciones]"
                        readonly>
                      </v-autocomplete>
                    </span>
                    <span v-else>
                      <v-autocomplete v-model="model.consignatario" :items="consignatarios" multiple
                      :loading="loading_consignatarios"  item-text="metadato" item-value="metadato"
                        label="Buscar por Consignatario" :rules="[validaOpciones]"
                        clearable>
                      </v-autocomplete>
                    </span>
                  </v-col>
                  <v-col sm="12" md="6" lg="6">
                      <v-autocomplete v-model="model.emisor" :items="emisores" multiple
                        clearable item-text="metadato" item-value="metadato"
                        :loading="loading_emisores" label="Buscar por Emisor/Destinatario">
                      </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row wrap>
                  <v-col sm="12" md="6" lg="6">
                      <v-autocomplete v-model="model.estado" :items="estados" multiple
                        clearable item-text="nombre" item-value="nombre"
                        :loading="loading_estados"  label="Buscar por Estado Tráfico">
                      </v-autocomplete>
                  </v-col>
                  <v-col sm="12" md="6" lg="6">
                      <v-autocomplete v-model="model.subestado" :items="subestados" multiple
                        clearable item-text="nombre" item-value="nombre"
                        :loading="loading_subestados" label="Buscar por Subestado Tráfico" 
                        persistent-hint hint="Al buscar por subestado se ignorará el estado seleccionado">
                      </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row wrap>
                  <v-col sm="12" md="4" lg="4">   
                    <v-text-field v-model="model.nombre" label="Buscar por nombre de tráfico" clearable />
                  </v-col>
                  <v-col sm="12" md="4" lg="4">                      
                        <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" v-model="model.fecha_de" clearable label="Fecha Pedimento Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'" :rules="[validaAnio, validaFecha]"></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_de" color="secondary"  scrollable locale="es-mx" @input="menu1 = false">
                                <v-spacer />

                                <v-btn color="secondary" x-small @click="menu1 = false">
                                    Cancelar
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col sm="12" md="4" lg="4">                      
                        <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" v-model="model.fecha_a" clearable label="Fecha Pedimento Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[validaAnio, validaFecha]"></v-text-field>
                            </template>
                            <v-date-picker v-model="model.fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu2 = false">
                                <v-spacer />

                                <v-btn color="secondary" x-small @click="menu2 = false">
                                    Cancelar
                                </v-btn>
                            </v-date-picker>
                        </v-menu>                      
                    </v-col>
                  </v-row>                  
              </v-container>
              </v-form>
              </v-card-text>

              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click.native="busquedaGeneral()">
                          <v-icon>search</v-icon>Buscar
                        </v-btn>                                            
              </v-card-actions>

              <v-card-text>
              <!-- Importador -->
              <v-flex xs12 style="margin-top: 50px" justify-end row fill-height>
                <v-speed-dial  direction="left" open-on-hover>
                       <template v-slot:activator>
                          <v-btn   x-small      fab    dark      color="primary"  >
                        	<v-icon>reorder</v-icon>
                      	</v-btn>
                      </template>
                  <exportar-excel
                    :data="datafiltered"
                    :exportFields="camposExcel"
                    name="Tráficos.xlsx"
                  >
                    <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                      <v-icon dark>get_app</v-icon>
                    </v-btn>
                  </exportar-excel>
                </v-speed-dial>
              </v-flex>              

              <v-client-table
                ref="vuetable"
                :data="traficos.items"
                :columns="columns"
                :options="options"
                class="elevation-2 pa-2">
                <template slot="noResults">
                  <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                </template>

                <template slot="mercancia" slot-scope="props">
                    <div class="mercanciaClass">
                        {{ props.row.mercancia }}
                    </div>                    
                </template>

              </v-client-table>
              
            </v-card-text>
          </base-material-card>
        </v-flex>
      </v-layout>
    </v-container>

   

  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";

export default {
  computed:{
    datafiltered(){
      if (this.$refs.vuetable != null)   {
        return this.$refs.vuetable.allFilteredData;
      }
      else{
        return this.traficos.items;
      }

    },
     is_consignatario(){
            return  this.$local_storage.get("perfil_grupo") == 43 ;;
        },
  },
  
  data() {
    return { fab: false,
      name: "datagrid",
      permisoSeleccionar: false,
      consignatarios:[],
      emisores:[],
      estados:[],
      subestados:[],
      subestados_filter:[],
      loading_estados:true,
      loading_subestados:false,
      loading_consignatarios:true,
      loading_emisores:true,
      show_loading: true,
      menu1: false,
      menu2: false,
      columns: ["rfc","nombre_trafico", "cliente", "proveedor", "mercancia", "puerto","transporte", "estatus", "eta", "aduana", "transporte_cargado", "ruta", "extras", "proveedor_meta"],
      options: {
        filterable: ["rfc","nombre_trafico", "cliente", "proveedor","proveedor_meta", "mercancia", "puerto","transporte", "estatus", "eta", "aduana", "transporte_cargado", "ruta", "extras"],
        sortable: ["rfc","nombre_trafico", "cliente", "proveedor","proveedor_meta", "mercancia", "puerto","transporte", "estatus", "eta", "aduana", "transporte_cargado", "ruta", "extras"],

        headings: {
          "rfc":"RFC Empresa",
          "nombre_trafico":"PO", 
          "cliente":"CLIENTE", 
          "proveedor":"PROVEEDOR", 
          "proveedor_meta":"PROVEEDOR METADATO",
          "mercancia":"TELA SEGÚN PEDIDO", 
          "puerto":"PUERTO",
          "transporte":"TRANSPORTE", 
          "estatus":"STATUS", 
          "eta":"ETA", 
          "aduana":"ADUANA", 
          "transporte_cargado":"TRANSPORTE CARGADO", 
          "ruta":"RUTA", "extras":"EXTRAS",
        },
        orderBy: { column: "rfc", ascending: true },        
      },
      camposExcel: {
          "RFC Empresa":"rfc",
          "PO":"nombre_trafico", 
          "CLIENTE":"cliente", 
          "PROVEEDOR":"proveedor",           
          "TELA SEGÚN PEDIDO":"mercancia", 
          "PUERTO":"puerto",
          "TRANSPORTE":"transporte", 
          "STATUS":"estatus", 
          "ETA":"eta", 
          "ADUANA":"aduana", 
          "TRANSPORTE CARGADO":"transporte_cargado", 
          "RUTA":"ruta", 
          "EXTRAS":"extras",
          "PROVEEDOR METADATO":"proveedor_meta",
      },
      breadcrumbs: [
        {
            text: "Inicio",
            disabled: false,
            to: "/trafico_index"
        },
        {
          text: "Reportes",
          disabled: false,
          to: ""
        },
        {
          text: "Reporte de Embarques",
          disabled: false,
          to: ""
        }
      ],
      search: "",
      traficos: {
        items: [],
        itemsCopy: [],        
      },
      rules: {
          required: v => !!v || 'Este campo es requerido',
      },
      busqueda: '',
      model:{
        rfc: "",
        nombre:"",
        consignatario:"",
        emisor:"",
        fecha_de: "",
        fecha_a: "",      
        estado: "",
        subestado: "",
      },
      
      resultadoBusqueda: [],
    };
  },  
  methods: {
    validaFecha: function(fecha){        
        if (fecha == "Invalid date")
            return "Fecha no válida."
        return true;
    },
    validaOpciones: function(){
      var vacios=0;
      for(var k in this.model){
        if (k!='rfc' && (this.model[k] == undefined || this.model[k] == "" ))
          vacios++;
      }
      if(vacios >= 7)
        return "Debe seleccionar al menos un filtro"
      
      return true;
      
    },
    validaAnio: function(){            
          if (this.model.fecha_de != "" && this.model.fecha_a != ""){
              var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
              var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
              var diferencia = fin.diff(inicio, 'days')     
              if (diferencia < 0)
                  return "La Fecha Final no debe ser menor a la Fecha Inicial."              
          }
          return true;
      },        
      parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
    formatDate (date) {
        if (!date) return null;

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`;
    },
    invertDate(date) {
        if (!date) return null

        const [day, month, year] = date.split('/')

        return `${year}-${month}-${day}`;
    },

    obtenerClientesConsignatariosPermitidos: function(){
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var id_usuario = this.$local_storage.get("id_usuario");      
      this.model.consignatario = [];
      this.model.rfc = ["NINGUNO"];
        axios.post(this.$hostname + "reportes_trafico/get_consignatarios_usuario/", {usuario:id_usuario})        
        .then(response => {
            if (response.data!= undefined){
                console.log(response.data);
                this.model.consignatario = response.data.consignatarios;
                this.model.rfc = response.data.clientes;
                this.consignatarios = [];
                this.emisores = [];
                if (response.data.clientes_id.length > 0){
                  response.data.clientes_id.forEach(cliente => {
                      this.cargarConsignatariosCliente(cliente);
                      this.cargarEmisoresCliente(cliente);
                  });                  
                } 
            }
            else
              this.$swal({
                type: "info",
                title: "Aviso",
                text: "No se encontraron registros con los filtros seleccionados",
                footer: ""
              });
        })
        .catch(error => {
          console.log(error);
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los registros",
            footer: ""
          });
        })
        .then(() => {
            this.loading_emisores=false; 
            this.loading_consignatarios=false;
            this.$root.$dialogLoader.hide();
        });
      
    },
        
    busquedaGeneral: function() {

        if (this.$refs.form.validate() ) {          

          var data = Vue.util.extend({}, this.model);
          for(var k in data){
            if (data[k] == undefined || data[k] == null )
              data[k] = "";
          }
          
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          this.traficos.items = [];
          axios
              .post(this.$hostname + "reportes_trafico/reporte_embarques/", data)              
              .then(response => {
                  if (response.data.length > 0){                    
                    this.traficos.items = response.data;                    
                  }
                  else
                    this.$swal({
                      type: "info",
                      title: "Aviso",
                      text: "No se encontraron registros con los filtros seleccionados",
                      footer: ""
                    });
              })
              .catch(error => {
                console.log(error);
                this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Ocurrió un error al obtener los registros",
                  footer: ""
                });
              })
              .then(() => {
                  this.$root.$dialogLoader.hide();
              });
        }

    },
    limpiaBusquedaGeneral: function() {
      this.busqueda = '';
      this.resultadoBusqueda = [];
      this.getTraficos();
    },
    
    cargarEstados: function () {                
          axios.get(this.$hostname + 'catalogos/estados_trafico/list_estados/')
          .then((res) => {
              if (typeof res.data !== 'undefined') {
                  this.estados = res.data;
              }
          })
          .catch((err) => {
              this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Error al obtener los Estados de Tráfico"
              });

              console.log(err.response);
          }).then(()=>{
                  this.loading_estados=false; 
                });      
    },
    cargarSubestados: function () {                
          axios.get(this.$hostname + 'catalogos/estados_trafico/')
          .then((res) => {
              if (typeof res.data !== 'undefined') {
                  this.subestados = res.data;
              }
          })
          .catch((err) => {
              this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Error al obtener los Estados de Tráfico"
              });

              console.log(err.response);
          }).then(()=>{
                  this.loading_subestados=false; 
                });   
    },
    cargarConsignatarios: function () {                
          axios.get(this.$hostname + 'catalogos/embarcadores_consignatarios/')
          .then((res) => {
              if (typeof res.data !== 'undefined') {
                  this.consignatarios = res.data;
              }
          })
          .catch((err) => {
              this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Error al obtener los Embarcadores"
              });

              console.log(err.response);
          }).then(()=>{
                  this.loading_consignatarios=false; 
                });
    },
    cargarConsignatariosCliente: async function (cliente) {               
      var datos = {
          cliente: cliente,
      };
      await axios.post(this.$hostname + 'catalogos/embarcadores_consignatarios/get_embarcadores_consignatarios/', datos)
          .then((res) => {
              if (typeof res.data !== 'undefined') {
                  this.consignatarios = this.consignatarios.concat(res.data);
              }
          })
          .catch((err) => {
              this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Error al obtener los Embarcadores"
              });

              console.log(err.response);
          });  
    },
    cargarEmisores: function () {                
          axios.get(this.$hostname + 'catalogos/emisores_destinatarios/')
          .then((res) => {
              if (typeof res.data !== 'undefined') {
                  this.emisores = res.data;
              }
          })
          .catch((err) => {
              this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Error al obtener los Emisores"
              });

              console.log(err.response);
          }).then(()=>{
                  this.loading_emisores=false; 
                });      
    },
    cargarEmisoresCliente: async function (cliente) {
                  
        var datos = {
            cliente: cliente,
        };            
        await axios.post(this.$hostname + 'catalogos/emisores_destinatarios/get_emisores/', datos)
            .then((res) => {
                if (typeof res.data !== 'undefined') {
                    this.emisores = this.emisores.concat(res.data);
                }
            })
            .catch((err) => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Error al obtener los Emisores"
                });

                console.log(err.response);
            });        
    },
  },
  created() {
    
    //var cliente_id = this.$local_storage.get("id_cliente","");
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario=="Soporte" || tipoUsuario=="Super Usuario"){            
        this.cargarConsignatarios();
        this.cargarEmisores();  
    } else {
        this.obtenerClientesConsignatariosPermitidos();
        this.permisoSeleccionar = true;
    }    
            
    this.cargarEstados();
    this.cargarSubestados();
    
  },
};

</script>
<style scoped>
.elevation-2 >>> .mercanciaClass{
    white-space: normal !important;
    max-width: 400px !important;    
    min-width: 400px !important;    
    text-align: justify !important;
}
</style>